import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="pt-28 pb-16 md:pt-36 md:pb-24 bg-gray-50" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-135">
          <div className="flex-1 text-center md:text-left" data-id="element-136">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-6" data-id="element-137">
              Créditos personales <br className="hidden md:block" data-id="element-138" />
              <span className="text-blue-900" data-id="element-139">rápidos y seguros</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto md:mx-0" data-id="element-140">
              En Finance Group te ayudamos a concretar tus proyectos con la
              mejor tasa del mercado. Simulá tu crédito hoy mismo y obtené
              respuesta inmediata.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-141">
              <a href="#simulador" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold rounded-lg text-white bg-blue-900 hover:bg-blue-800 transition-colors shadow-lg hover:shadow-xl" data-id="element-142">
                Simular Crédito
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-143" />
              </a>
              <a href="#servicios" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold rounded-lg text-blue-900 bg-white border-2 border-blue-900 hover:bg-gray-50 transition-colors" data-id="element-144">
                Conocer más
              </a>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-center gap-6 justify-center md:justify-start text-sm text-gray-600 font-medium" data-id="element-145">
              <div className="flex items-center gap-2" data-id="element-146">
                <CheckCircle2 className="h-5 w-5 text-green-600" data-id="element-147" />
                <span data-id="element-148">Aprobación en 24hs</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-149">
                <CheckCircle2 className="h-5 w-5 text-green-600" data-id="element-150" />
                <span data-id="element-151">Mínimos requisitos</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-152">
                <CheckCircle2 className="h-5 w-5 text-green-600" data-id="element-153" />
                <span data-id="element-154">100% Online</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg relative" data-id="element-155">
            <div className="absolute inset-0 bg-blue-900 rounded-2xl transform rotate-3 opacity-10" data-id="element-156"></div>
            <img src="https://cdn.magicpatterns.com/uploads/wuBX5cDWhF8NUnHBkt4Tj4/Familie_digital_organisieren.jpg" alt="Familia gestionando su crédito desde el celular" className="rounded-2xl shadow-2xl relative z-10 object-cover w-full h-[400px] md:h-[500px]" data-id="element-157" />
          </div>
        </div>
      </div>
    </section>;
}